class ApiClient {
    constructor(config) {
        this.sessionToken = null; // ← добавили
        this.config = config;
    }
    // Вызвать один раз при старте
    async init() {
        const result = await this.request('/calculator/init');
        this.sessionToken = result.token;
        return { config: result.config };
    }
    getHeaders(extra) {
        const headers = {
            'Content-Type': 'application/json',
            'X-API-Key': this.config.apiKey,
            'X-Calculator-Id': this.config.calculatorId,
        };
        if (this.sessionToken) {
            headers['X-Session-Token'] = this.sessionToken;
        }
        return { ...headers, ...extra };
    }
    async request(path, body, options) {
        const isBinary = body instanceof Uint8Array || body instanceof ArrayBuffer;
        const isFormData = body instanceof FormData;
        let requestBody;
        if (!body)
            requestBody = undefined;
        else if (isFormData)
            requestBody = body;
        else if (isBinary)
            requestBody = body;
        else
            requestBody = JSON.stringify(body);
        // Убираем Content-Type для FormData — браузер сам добавит с правильным boundary
        const baseHeaders = this.getHeaders(options?.headers);
        const requestHeaders = isFormData
            ? Object.fromEntries(Object.entries(baseHeaders).filter(([k]) => k.toLowerCase() !== 'content-type'))
            : baseHeaders;
        const res = await fetch(`${this.config.apiUrl}${path}`, {
            method: 'POST',
            headers: requestHeaders,
            body: requestBody,
        });
        return this.handleResponse(res);
    }
    async requestGet(path) {
        const res = await fetch(`${this.config.apiUrl}${path}`, {
            method: 'GET',
            headers: this.getHeaders(),
        });
        return this.handleResponse(res);
    }
    async handleResponse(res) {
        if (res.status === 401) {
            const error = new Error('Unauthorized');
            this.config.onUnauthorized?.();
            this.config.onError?.(error);
            throw error;
        }
        if (res.status === 403)
            throw new Error('Forbidden: Domain not allowed');
        if (res.status === 429) {
            const retryAfter = res.headers.get('Retry-After');
            throw new Error(`Too many requests. Retry after ${retryAfter}s`);
        }
        if (!res.ok)
            throw new Error(`HTTP error! status: ${res.status}`);
        const json = await res.json();
        if (!json.ok) {
            const error = new Error(json.error || 'API error');
            this.config.onError?.(error);
            throw error;
        }
        return json.result;
    }
    updateApiKey(newKey) { this.config.apiKey = newKey; }
    updateConfig(newConfig) {
        this.config = { ...this.config, ...newConfig };
    }
}
export function createApiClient(config) {
    return new ApiClient(config);
}
